import {format} from 'date-fns'
import './AppointmentIcon.css'

interface AppointmentIconProps {
  title: string
  date: string
  onClick?: () => void
}

export const AppointmentIcon = ({title, date, onClick}: AppointmentIconProps) => {
  const timeLabel = (() => {
    const parsed = new Date(date)
    return Number.isNaN(parsed.getTime()) ? '' : format(parsed, 'hh:mm a')
  })()

  return (
    <div
      className='appointment-icon'
      title={`${timeLabel} ${title}`.trim()}
      role={onClick ? 'button' : undefined}
      onClick={onClick}
    >
      <i className='bi bi-calendar-check'></i>
      <span className='appointment-icon-name'>
        {timeLabel ? `${timeLabel} · ${title}` : title}
      </span>
    </div>
  )
}
